module.exports = __webpack_public_path__ + "static/assets/17d02d95760a16d3e92f7c6cfe95b310.png";